//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueBarcode from "vue-barcode";
import { mapActions } from "vuex";
export default {
  components: {
    barcode: VueBarcode,
  },
  data() {
    return {
      barcodes: [
        {
          text: "A0101",
        },
        {
          text: "B0101",
        },
      ],
    };
  },
  methods: {
    ...mapActions("main", ["getBarcodes", "getLocation"]),

    openFram() {
      var divContents = document.getElementById("cfg").innerHTML;
      var a = window.open("", "", "height=500, width=500");
      a.document.write("<html>");
      a.document.write("<body >");
      a.document.write(divContents);
      a.document.write("</body></html>");
      a.document.write(
        "<style type='text/css' media='print'> @page {size: auto;margin: 0mm;}</style>"
      );

      a.document.close();
      a.print();
    },
  },
  async created() {},
};
